"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatFilesize = void 0;
var base = {
  style: 'unit',
  unitDisplay: 'short',
  maximumFractionDigits: 1
};
var NUMBER_FORMATTERS = ['byte', 'kilobyte', 'megabyte', 'gigabyte', 'terabyte', 'petabyte'].map(function (unit) {
  return new Intl.NumberFormat(undefined, Object.assign(Object.assign({}, base), {
    unit: unit
  }));
});
var BYTES_PER_KB = 1000;

function formatFilesize(bytes) {
  if (bytes !== undefined && bytes !== null) {
    var size = Math.abs(bytes);
    var formatterIndex = 0;

    while (size >= BYTES_PER_KB && formatterIndex < NUMBER_FORMATTERS.length - 1) {
      size /= BYTES_PER_KB;
      ++formatterIndex;
    }

    return NUMBER_FORMATTERS[formatterIndex].format(size);
  } else {
    return null;
  }
}

exports.formatFilesize = formatFilesize;